module.exports = __webpack_public_path__ + "react-public-static/media/background.1c097c74.svg";